'use client';

import Script from 'next/script';

interface VideoPlayerProps {
  videoUrl?: string;
  thumbnailUrl?: string;
  title?: string;
  onPlay?: () => void;
  onPause?: () => void;
  onEnded?: () => void;
  className?: string;
}

const VideoPlayer = ({
  className = '',
}: VideoPlayerProps) => {
  return (
    <>
      <Script data-component-id="src/components/common/VideoPlayer.tsx:20:6" data-component-path="src/components/common/VideoPlayer.tsx" data-component-line="20" data-component-file="VideoPlayer.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%2C%22src%22%3A%22https%3A%2F%2Ffast.wistia.net%2Fplayer.js%22%7D" src="https://fast.wistia.net/player.js" strategy="afterInteractive" />
      
      <div data-component-id="src/components/common/VideoPlayer.tsx:22:6" data-component-path="src/components/common/VideoPlayer.tsx" data-component-line="22" data-component-file="VideoPlayer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`w-full ${className}`}>
        <div data-component-id="src/components/common/VideoPlayer.tsx:23:8" data-component-path="src/components/common/VideoPlayer.tsx" data-component-line="23" data-component-file="VideoPlayer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22wistia_responsive_padding%22%7D" className="wistia_responsive_padding" style={{ padding: '60.63% 0 0 0', position: 'relative' }}>
          <div data-component-id="src/components/common/VideoPlayer.tsx:24:10" data-component-path="src/components/common/VideoPlayer.tsx" data-component-line="24" data-component-file="VideoPlayer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22wistia_responsive_wrapper%22%7D" className="wistia_responsive_wrapper" style={{ height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' }}>
            <iframe data-component-id="src/components/common/VideoPlayer.tsx:25:12" data-component-path="src/components/common/VideoPlayer.tsx" data-component-line="25" data-component-file="VideoPlayer.tsx" data-component-name="iframe" data-component-content="%7B%22elementName%22%3A%22iframe%22%2C%22src%22%3A%22https%3A%2F%2Ffast.wistia.net%2Fembed%2Fiframe%2Fsspgc7c4go%3Fweb_component%3Dtrue%26seo%3Dtrue%22%2C%22className%22%3A%22wistia_embed%22%2C%22name%22%3A%22wistia_embed%22%7D" 
              src="https://fast.wistia.net/embed/iframe/sspgc7c4go?web_component=true&seo=true" 
              title="Avarius VSL Video" 
              allow="autoplay; fullscreen" 
              allowTransparency={true}
              frameBorder="0" 
              scrolling="no" 
              className="wistia_embed" 
              name="wistia_embed" 
              width="100%" 
              height="100%"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoPlayer;